import React, { useState, useEffect } from 'react';
import { Container } from '@chakra-ui/react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { LoginForm } from './LoginForm';
import { SignUpForm } from './SignUpForm';
import { useAuth } from '../../hooks/useAuth';

export const AuthPage = () => {
  const [isSignUp, setIsSignUp] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  const returnUrl = searchParams.get('returnUrl');

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Redirect authenticated users to their intended destination
  useEffect(() => {
    if (user) {
      if (returnUrl) {
        navigate(decodeURIComponent(returnUrl), { replace: true });
      } else {
        navigate(user.isAdmin ? '/admin' : '/', { replace: true });
      }
    }
  }, [user, returnUrl, navigate]);

  const toggleMode = () => {
    setIsSignUp(!isSignUp);
  };

  return (
    <Container maxW="container.sm" py={{ base: 4, md: 8 }} px={{ base: 4, md: 6 }}>
      {isSignUp ? (
        <SignUpForm onToggleMode={toggleMode} returnUrl={returnUrl} />
      ) : (
        <LoginForm onToggleMode={toggleMode} returnUrl={returnUrl} />
      )}
    </Container>
  );
};
